const getIsBelowMaxSize = (maxFileSize, fileSize) => maxFileSize && maxFileSize > 0 ? fileSize < maxFileSize : true;
export default getIsBelowMaxSize;
